<script lang="ts">

  import httpClient from "$lib/axios-client"
  import { Button } from "$lib/components/ui/button"
  import { Card, CardContent, CardHeader, CardTitle } from "$lib/components/ui/card"
  import type { _response } from "$lib/data/type/_response"
  import { createQuery } from "@tanstack/svelte-query"
  import ChevronRightIcon from "@lucide/svelte/icons/chevron-right"

  type Recap = {
    plan_count: number
    plan_approved: number
    real_count: number
    real_approved: number
  }

  let {
    prefix,
    date,
  }: {
    prefix: string
    date: string
  } = $props()

  const query = createQuery(() => ({
    queryKey: ["activity-approval", { date }],
    queryFn: async () => {
      return (
        await httpClient.get<_response<Recap>>(`/api/${prefix}/activity/approval-recap`, {
          params: { date },
        })
      ).data.result
    },
  }))

</script>

<div class="mx-3">
  <h3 class="mb-2 text-sm font-semibold">Approval</h3>
  <div class="grid grid-cols-2 gap-2">
    {#if query.isFetching}
      <Card class="animate-pulse gap-0 rounded-md bg-foreground/10 py-0 shadow-none">
        <CardHeader class="px-2 pt-2 pb-0">
          <CardTitle class="text-xs font-normal leading-none opacity-0">-</CardTitle>
        </CardHeader>
        <CardContent class="px-2 py-2 text-center text-xl font-semibold tabular-nums tracking-tight opacity-0">
          -
        </CardContent>
      </Card>
      <Card class="animate-pulse gap-0 rounded-md bg-foreground/10 py-0 shadow-none">
        <CardHeader class="px-2 pt-2 pb-0">
          <CardTitle class="text-xs font-normal leading-none opacity-0">-</CardTitle>
        </CardHeader>
        <CardContent class="px-2 py-2 text-center text-xl font-semibold tabular-nums tracking-tight opacity-0">
          -
        </CardContent>
      </Card>
    {:else}
      <a href={`/${prefix}/activity-approval-plan?date=${date}`}>
        <Card class="gap-0 rounded-md py-0 shadow-none">
          <CardHeader class="px-2 pt-2 pb-0">
            <CardTitle class="text-xs font-normal leading-none">Rencana</CardTitle>
          </CardHeader>
          <CardContent class="px-2 py-2 text-center text-xl font-semibold tabular-nums tracking-tight">
            {query.data?.plan_approved ?? 0} / {query.data?.plan_count ?? 0}
          </CardContent>
        </Card>
      </a>
      <a href={`/${prefix}/activity-approval-real?date=${date}`}>
        <Card class="gap-0 rounded-md py-0 shadow-none">
          <CardHeader class="px-2 pt-2 pb-0">
            <CardTitle class="text-xs font-normal leading-none">Realisasi</CardTitle>
          </CardHeader>
          <CardContent class="px-2 py-2 text-center text-xl font-semibold tabular-nums tracking-tight">
            {query.data?.real_approved ?? 0} / {query.data?.real_count ?? 0}
          </CardContent>
        </Card>
      </a>
    {/if}
    <Button
      href={`/${prefix}/staff`}
      variant="outline"
      class="col-span-2 flex justify-between py-0 text-xs shadow-none">
      Data Sales
      <ChevronRightIcon/>
    </Button>
  </div>
</div>
